interface UnusedTicketsBarProps {
  hasUnusedTickets?: boolean;
}

const STATES = {
  unused: {
    icon: "/assets/images/botb-pass-members/wallet-tickets.webp",
    iconAlt: "Wallet with tickets",
    title: "You have unused tickets",
    subtitle: "Your next win could be one ticket away",
    ariaLabel: "View unused tickets",
  },
  allIn: {
    icon: "/assets/images/botb-pass-members/trophy.webp",
    iconAlt: "Trophy",
    title: "All your Pass entries are in",
    subtitle: "Boost your odds with extra tickets",
    ariaLabel: "View featured competitions",
  },
};

export default function UnusedTicketsBar({ hasUnusedTickets = false }: UnusedTicketsBarProps) {
  const state = hasUnusedTickets ? STATES.unused : STATES.allIn;

  return (
    <div className="bg-primary border-t border-[#ff911b] flex items-center justify-between gap-3 p-3 rounded-[40px] shadow-[0px_25px_50px_0px_rgba(0,0,0,0.25)]">
      <div className="flex items-center gap-2 min-w-0">
        <div className="bg-white flex items-center justify-center w-10 h-10 rounded-full shadow-[0px_1.5px_8px_0px_rgba(0,0,0,0.2)] shrink-0">
          <img src={state.icon} alt={state.iconAlt} className="w-8 h-8 object-cover" />
        </div>
        <div className="flex flex-col gap-0.5 min-w-0">
          <p className="m-0 p-0 text-white text-base font-semibold font-jost whitespace-nowrap">{state.title}</p>
          <p className="m-0 p-0 text-white/90 text-xs font-normal font-jost whitespace-nowrap">{state.subtitle}</p>
        </div>
      </div>

      <a
        href={hasUnusedTickets ? "/account/my-wallet" : "/#featured"}
        aria-label={state.ariaLabel}
        className="bg-white text-dark-1 text-sm font-medium font-jost h-10 w-[60px] rounded-full flex items-center justify-center shrink-0">
        View
      </a>
    </div>
  );
}
